import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { FeedbackService } from 'src/app/_services/feedback.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { UtilityService } from 'src/app/_services/utility.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  filterFeedback = {
    selected_user: [''],
    selected_category: [''],
    filter_status: [''],
    filterSearch_authors: '',
    filterSearch_category: '',
    filterSearch_status: '',
    filter_text: '',
    per_page: 0, // Aggiungi il parametro per_page
    current_page: 1, // Aggiungi il parametro current_page
    feedNotify: null
  };

  filtersCategories = {
    filterSearch_category: '',
    selected_user: [''],
    filter_status: ['']
  };

  filtersStatus = {
    filterSearch_status: '',
    selected_user: [''],
    selected_category: ['']
  };

  filtersAuth = {
    filterSearch_authors: '',
    selected_category: [''],
    selected_status: ['']
  };
  pagination = {
    current_page: 1,
    total_items: 0,
    per_page: 10,
    total_pages: 0
  };

  FeedbackData: any[];
  authors: any;
  categories: any;
  status: any;
  selectedAuth = new Array();
  selectedCategory = new Array();
  selectedStatus = new Array();
  toggleAllAuth: boolean = false;
  toggleAllCategories: boolean = false;
  toggleAllStatus: boolean = false;
  authorControl = new FormControl<string>('');
  authControl = new FormControl<any>('');
  CategoryControl = new FormControl<any>(''); //utilizzato per filtri
  statusControl = new FormControl<string>('');
  searchControl = new FormControl<string>('');
  FeedbackControl = new FormControl<string>('');
  addCategoryControl = new FormControl<any>(''); //utilizzato per aggiunta e modifica
  feedbackForm: FormGroup;
  searchForm: FormGroup;
  editFeedForm: FormGroup;
  newCommentForm: FormGroup;
  editCommentForm: FormGroup;
  comments: any[] = [];
  inputI: number | undefined;
  myRole: any;
  loggedProfileData: any;
  editControl: boolean = false;
  id: any;
  edit: boolean = false;
  path: string;
  modalAction: string;
  editMode: boolean = false;
  likeInProgress: boolean = false;
  clickedFeedbackId: number | null = null;
  filterUserIdDefault: FormControl = new FormControl('');
  private searchChanged: Subject<string> = new Subject<string>();
  toggle: boolean = true;
  isExpanded: boolean = false;
  feedbackId: any;
  profile: any;
  authorProfile: any;
  authorId: any;
  CategoryOptions: any;
  feedNotify: any;
  editingCommentId: number;
  showButton: boolean = false;

  isMobile: boolean = false;
  isDesktop: boolean = false;
  isTablet: boolean = false;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '290px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    defaultParagraphSeparator: '',
    sanitize: true,
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo',
        'fontSize',
        'fontName',
        'subscript',
        'superscript',
        'htmlCode',
        'insertHorizontalRule',
        'clearFormatting'
      ]
    ]
  };

  constructor(
    private readonly feedbackService: FeedbackService,
    private readonly profileService: ProfileService,
    public utilityService: UtilityService,
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,
    private readonly paginatorIntl: MatPaginatorIntl,
    private readonly router: Router,
    private readonly title: Title
  ) {
    this._initFeedbackForm();
    this._initSearchForm();
    this._initCommentForms();

    this.searchChanged.pipe(debounceTime(1000)).subscribe(() => {
      this.getFeedback();
    });
  }

  async ngOnInit(): Promise<void> {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 567) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.isDesktop = true;
    }

    this.loggedProfileData = await this.profileService.getUserRoleAsync();
    this.myRole = this.loggedProfileData.roles[0].name;
    this.utilityService.setTitle('Suggerimenti');
    this.title.setTitle('Suggerimenti | Sviluppo Personale');
    this.setupRouteParams();
    this.getFeedback();
    this.pageTranslate();
  }

  onDropdownOpened(isOpened: boolean): void {
    if (isOpened) {
      this.setValueChanges();
    }
  }
  private setupRouteParams(): void {
    this.route.queryParams.subscribe(params => {
      this.feedbackId = params['id'];
      this.feedNotify = params['id']; //recupera id feedback per notifica
      this._initFeedbackForm();
    });
  }
  setValueChanges() {
    //valorizza select e le aggiorna al valuechanges
    this.authorControl.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value: any) => {
        this.getFeedback();
      });
    this.CategoryControl.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value: any) => {
        this.getFeedback();
      });
    this.statusControl.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value: any) => {
        this.getFeedback();
      });
  }

  _initSearchForm() {
    this.authorControl.patchValue('');
    this.CategoryControl.patchValue('');
    this.statusControl.patchValue('');
    this.searchControl.patchValue('');
    this.searchForm = this.fb.group({
      selected_user: this.authorControl.value,
      selected_category: this.CategoryControl.value,
      filter_status: this.statusControl.value,
      filter_text: this.searchControl.value,
      toggle: this.toggle
    });
  }

  getFeedback() {
    let utility = this.utilityService;
    this.filterFeedback = {
      selected_user: this.searchForm.controls['selected_user'].value,
      selected_category: this.searchForm.controls['selected_category'].value,
      filter_status: this.searchForm.controls['filter_status'].value,
      filterSearch_authors: this.authorControl.value || '',
      filterSearch_category: this.CategoryControl.value || '',
      filterSearch_status: this.statusControl.value || '',
      filter_text: this.searchForm.controls['filter_text'].value, //filtro ricerca nella search bar
      per_page: this.pagination.per_page, // Aggiungi il parametro per_page
      current_page: this.pagination.current_page, // Aggiungi il parametro current_page
      feedNotify: this.feedNotify
    };
    this.showButton = this.filterFeedback?.feedNotify ?? false; //mostra il pulsante rimuovi filtri solo se si proviene da Notifiche
    if (typeof this.filterFeedback.filterSearch_category == 'string') {
      this.feedbackService.getFeedback(this.filterFeedback).subscribe({
        next: (res: any) => {
          this.FeedbackData = res.result.feedback;
          this.authors = res.result.user_feedback;
          this.status = res.result.status_feedback;
          this.categories =
            res.result.categories_feedback == 0
              ? null
              : res.result.categories_feedback;
          this.pagination = res.result.pagination;
          this.processFeedbackData(this.FeedbackData, utility);
          this.router.navigate(['/secure/dashboard/feedback']);
        },
        error: (err: any) => {
          console.error('Error fetching feedback:', err);
        }
      });
    }
  }

  handleClick() {
    //bottone che rimuove filtri
    this.getFeedback();
    this.router.navigate(['/secure/dashboard/feedback']);
    this.resetUserSelect(this.searchForm.value);
  }

  processFeedbackData(feedbackData: any[], utility: any) {
    feedbackData.forEach((feedback: any) => {
      if (feedback.user && feedback.user.filestorage) {
        feedback.user.filestorage.path = utility.getSanitizeUrl(
          feedback.user.filestorage.path
        );
      }
      if (feedback.comments) {
        feedback.comments.forEach((request: any) => {
          if (request.user && request.user.filestorage) {
            request.user.filestorage.path = utility.getSanitizeUrl(
              request.user.filestorage.path
            );
          }
        });
      }
    });
  }

  checkAll() {
    if (
      this.searchForm.controls['selected_user'].value.length !=
      this.authors.length
    ) {
      this.toggleAllAuth = false;
    } else {
      this.toggleAllAuth = true;
    }
    if (
      this.searchForm.controls['selected_category'].value.length !=
      this.categories.length
    ) {
      this.toggleAllCategories = false;
    } else {
      this.toggleAllCategories = true;
    }
    if (
      this.searchForm.controls['filter_status'].value.length !=
      this.filtersStatus
    ) {
      this.toggleAllStatus = false;
    } else {
      this.toggleAllStatus = true;
    }
  }
  //Selezione di tutti i valori in una volta sola di ogni singola  select
  toggleSelectAllAuth() {
    const allAuthors = this.authors.map((author: { id: any }) => author.id);
    if (this.toggleAllAuth) {
      this.searchForm.controls['selected_user'].setValue([]);
    } else {
      this.searchForm.controls['selected_user'].setValue(allAuthors);
    }
    this.toggleAllAuth = !this.toggleAllAuth;
    this.getFeedback();
  }

  toggleSelectAllCategories() {
    const allCategoryIds = this.categories.map((item: { id: any }) => item.id);

    if (this.toggleAllCategories) {
      this.searchForm.controls['selected_category'].setValue([]);
    } else {
      this.searchForm.controls['selected_category'].setValue(allCategoryIds);
    }
    this.toggleAllCategories = !this.toggleAllCategories;
    this.getFeedback();
  }

  toggleSelectAllStatus() {
    const allStatusValues = [
      'Risolti',
      'Ricevuti',
      'In Lavorazione',
      'Non attuabile al momento'
    ];
    this.toggleAllStatus = !this.toggleAllStatus;
    this.searchForm.controls['filter_status'].setValue(
      this.toggleAllStatus ? allStatusValues : []
    );
    this.getFeedback();
  }

  addToArr(type: string) {
    // aggiunta valori selezionai in array per mandare valori selezionati al BE
    let arr = this.searchForm.controls[type].value;
    switch (type) {
      case 'selected_user':
        this.selectedAuth = this.authors.filter((obj: { id: string }) =>
          arr.includes(obj.id)
        );
        break;
      case 'selected_category':
        this.selectedCategory = this.categories.filter((obj: { id: string }) =>
          arr.includes(obj.id)
        );
        break;
      case 'filter_status':
        this.selectedStatus = this.status.filter((obj: { status: string }) =>
          arr.includes(obj.status)
        );
        break;
      default:
        break;
    }
  }

  resetControl(formControl: FormControl) {
    formControl.setValue('');
  }
  /* rimozione degli elementi filtrati da chips e di conseguenza dalla select */
  removedItem(i: any, array: any[], type: string) {
    array.splice(i, 1);
    let arr = [];
    for (let i = 0; i < array.length; i++) {
      if (array[i].id) {
        arr.push(array[i].id);
      } else {
        arr.push(array[i].status);
      }
    }
    this.searchForm.controls[type].setValue(arr);
    switch (type) {
      case 'selected_user':
        if (this.searchForm.controls['selected_user'].value.length == 0) {
          this.toggleAllAuth = false;
        }
        break;
      case 'selected_category':
        if (this.searchForm.controls['selected_category'].value.length == 0) {
          this.toggleAllCategories = false;
        }
        break;
      case 'filter_status':
        if (this.searchForm.controls['filter_status'].value.length == 0) {
          this.toggleAllStatus = false;
        }
        break;
    }
    this.getFeedback();
  }

  resetSelect(control: FormControl, values: any) {
    switch (control) {
      case this.statusControl:
        this.statusControl.patchValue('');
        this.toggleAllStatus = false;
        this.selectedStatus = [];
        break;
      case this.authorControl:
        this.authorControl.patchValue('');
        this.toggleAllAuth = false;
        this.selectedAuth = [];
        break;
      case this.CategoryControl:
        this.CategoryControl.patchValue('');
        this.toggleAllCategories = false;
        this.selectedCategory = [];
        break;
      default:
        break;
    }
    this.getFeedback();
  }

  resetUserSelect(control: string) {
    if (control == 'autore') {
      this.searchForm.controls['selected_user'].setValue('');
      this.toggleAllAuth = false;
      this.selectedAuth = [];
    } else if (control == 'categoria') {
      this.searchForm.controls['selected_category'].setValue('');
      this.toggleAllCategories = false;
      this.selectedCategory = [];
    } else if (control == 'stato') {
      this.searchForm.controls['filter_status'].setValue('');
      this.toggleAllStatus = false;
      this.selectedStatus = [];
    }
    this.getFeedback();
  }

  onPageChange(pageEvent: PageEvent) {
    this.pagination.current_page = pageEvent.pageIndex + 1;
    this.pagination.per_page = pageEvent.pageSize;
    this.getFeedback();
  }
  // Metodo per tradurre descrizione di default Material per paginazione
  pageTranslate() {
    this.paginatorIntl.itemsPerPageLabel = 'Elementi per pagina';
    this.paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };
  }

  _initFeedbackForm() {
    //inizializzazione dei form
    this.addCategoryControl.reset();
    this.feedbackForm = this.fb.group({
      alias: ['', Validators.required],
      description: ['', Validators.required],
      feedbackcategory_id: ['', Validators.required]
    });
    this.addCategoryControl.valueChanges.subscribe((value: any) => {
      this.feedbackForm.patchValue({
        feedbackcategory_id: value ? value.id : '',
        filtersearch_Category: value ? value.alias : ''
      });
    });
    this.editFeedForm = this.fb.group({
      id: [Validators.required],
      alias: ['', Validators.required],
      description: ['', Validators.required],
      feedbackcategory_id: [null, Validators.required]
    });
  }
  editForm(feedback: any) {
    this.edit = true;
    this.feedbackId = feedback.id;
    this.addCategoryControl.patchValue(feedback.category);
    this.editFeedForm.patchValue({
      alias: feedback?.alias,
      description: feedback?.description,
      feedbackcategory_id: feedback?.category?.alias
    });
  }

  _initCommentForms() {
    this.newCommentForm = this.fb.group({
      description: ['', Validators.required],
      commentable_type: ['feedback', Validators.required],
      commentable_id: [0, Validators.required]
    });

    this.editCommentForm = this.fb.group({
      id: ['', Validators.required],
      description: ['', Validators.required]
    });
  }
  openSwal(icon: SweetAlertIcon | undefined, title: string): void {
    //gestisco sweetAlert per richiamarlo ogni volta
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      icon: icon,
      iconColor: '#FFB26B',
      title: title,
      didOpen: toast => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  }
  addFeedback() {
    const feedbackData = {
      author_id: this.authorControl.value // ID dell'autore del feedback
    };
    this.feedbackService.addFeedback(this.feedbackForm.value).subscribe({
      next: res => {
        this.getFeedback();

        // Aggiorna il form con nuovi valori
        this.feedbackForm.patchValue({
          alias: '',
          description: '',
          feedbackcategory_id: ''
        });
        this.edit = false;
        this.openSwal('success', 'Feedback inviato con successo');
        this.getFeedback();
      },
      error: () => {
        this.openSwal('error', 'Non è stato possibile aggiungere un feedback');
      }
    });
  }
  updateFeedback() {
    this.editFeedForm.controls['feedbackcategory_id'].patchValue(
      this.addCategoryControl.value.id
    );

    this.feedbackService
      .updateFeedback(this.feedbackId, this.editFeedForm.value)
      .subscribe({
        next: res => {
          this.resetSelect(this.CategoryControl, this.categories);
          this.feedbackForm.patchValue({
            alias: '',
            description: '',
            feedbackcategory_id: ''
          });
          this.edit = true;
          this.openSwal('success', 'Feedback modificato con successo');
        },
        error: () => {
          this.openSwal(
            'error',
            'Impossibile modificare il feedback selezionato'
          );
        }
      });
  }
  delFeedback(feedback_id: any) {
    Swal.fire({
      text: 'Sicuro di voler eliminare questo feedback?',
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      focusConfirm: false,
      customClass: {
        popup: 'main-font'
      },
      backdrop: '#f4f3efad',
      position: 'center'
    }).then(result => {
      if (result.isConfirmed) {
        this.feedbackService.deleteFeedback(feedback_id).subscribe({
          next: (res: any) => {
            {
              this.getFeedback();
              this.openSwal('success', 'Feedback eliminato con successo');
            }
          },
          error: (err: any) => {
            this.openSwal(
              'error',
              'Imppossibile eliminare il feedback selezionato'
            );
          }
        });
      }
    });
  }

  setModalData(action: string, data?: any) {
    //settaggio valori modale nel caso di modifica
    this.modalAction = action;

    if (this.modalAction == 'edit') {
      this.editFeedForm.patchValue({
        id: data.id,
        feedbackcategory_id: data.feedbackcategory_id,
        alias: data.alias,
        description: data.description
      });
    }
  }

  openModalDelete(id: any) {
    this.feedbackId = id;
  }

  checkRole(item: any) {
    return this.myRole == 'admin' || item.user_id === this.loggedProfileData.id;
  }

  // intercetta la modifica del valore del filtraggio per titolo
  onSearchChange(newValue: any) {
    this.pagination.current_page = 1;
    this.searchChanged.next(newValue);
  }

  displayCategoryFn(cateogry: any): string {
    return cateogry ? cateogry.alias : '';
  }

  toggleText(i: number) {
    if (i) this.isExpanded = !this.isExpanded;
  }

  stopEventPropagation(event: Event) {
    event.stopPropagation();
  }

  getElement(element: any) {
    this.profileService.profileUser(element).subscribe(res => {
      this.profile = res.result;
    });
  }

  setLike(item: any) {
    return item.likes.some((like: any) => like.likes_id == item.id);
  }

  toggleLike(item: any) {
    this.likeInProgress = true;
    setTimeout(() => {
      this.feedbackService.toggleLike(item.id, item.user_id).subscribe({
        next: res => {
          if (res.message === 'Query eseguita, like aggiunto') {
            item.likes_count++;
            item.likes.push(res.result);
          } else {
            item.likes_count--;
            item.likes = item.likes.filter(
              ({ likes_id }: any) => likes_id != item.id
            );
          }
          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title:
              res.message == 'Query eseguita, like aggiunto'
                ? 'Like aggiunto'
                : 'Like rimosso',
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          this.likeInProgress = false;
          if (this.toggle) this.getFeedback();
        },
        error: () => {
          this.openSwal(
            'error',
            'Non è stato possibile aggiungere like al feedback'
          );
        }
      });
    }, 500);
  }
  getLikesNames(item: any): string {
    let names = '';
    for (let i = 0; i < item.likes.length; i++) {
      names += `${item.likes[i].user.first_name} ${item.likes[i].user.last_name}`;
      if (i !== item.likes.length - 1) {
        names += ', ';
      }
    }
    return names;
  }

  newComment(request_id: number) {
    this.newCommentForm.controls['commentable_id'].patchValue(request_id);
    this.feedbackService.addComment(this.newCommentForm.value).subscribe({
      next: (res: any) => {
        this.getFeedback();
        this.openSwal('success', 'Commento aggiunto con successo');
      },
      error: (err: any) => {
        this.openSwal('error', 'Impossibile inserire commento');
      }
    });
    this._initCommentForms();
  }

  editComment(comment_id: number) {
    this.feedbackService
      .editComment(comment_id, this.editCommentForm.value)
      .subscribe({
        next: (res: any) => {
          this.getFeedback();
          this._initCommentForms();
          this.editMode = false;
          this.editingCommentId = 0;
          this.openSwal('success', 'Commento modificato con successo');
        },
        error: (err: any) => {
          this.openSwal('error', 'Impossibile eliminare il commento');
        }
      });
  }

  delComment(comment_id: number) {
    Swal.fire({
      text: 'Sicuro di voler eliminare questo commento?',
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      focusConfirm: false,
      customClass: {
        popup: 'main-font'
      },
      backdrop: '#f4f3efad',
      position: 'center'
    }).then(result => {
      if (result.isConfirmed) {
        this.feedbackService.destroyComment(comment_id).subscribe({
          next: (res: any) => {
            this.getFeedback();
          }
        });

        this.openSwal('success', 'Commento eliminato con successo');
      }
    });
  }

  enableEditMode(comment_id: number, description: string) {
    this.inputI = comment_id;
    this.editControl = true;
    this.editMode = true;
    this.editingCommentId = comment_id; // Memorizza l'ID del commento in modalità di modifica

    this.editCommentForm.patchValue({
      id: comment_id,
      description: description
    });
  }

  // Metodo per cambiare lo stato del feedback
  changeFeedbackStatus(feedbackId: number, newStatus: string): void {
    this.feedbackService.changeStatus(feedbackId, newStatus).subscribe(
      response => {
        this.getFeedback();
        this.openSwal('success', 'Stato modificato con successo');
      },
      error => {
        this.openSwal('error', 'Non hai i permessi per modificare lo stato');
      }
    );
  }

  feedbackTrackBy(index: any, feedback: any) {
    return feedback.id;
  }

  clickEditFeed(itemId: number) {
    this.clickedFeedbackId = itemId;
  }

  getFeedbackUserIds(): string[] {
    // cerco feed cliccato al momento della modifica e recupero utente
    let userIds: string[] = [];

    if (this.clickedFeedbackId !== null) {
      //cerco il feedback corrispondente al feed cliccato
      const feedback = this.FeedbackData.find(
        feed => feed.id === this.clickedFeedbackId
      );
      //verifico se il feedback trovato contiene un utente
      if (feedback && feedback.user && feedback.user.id) {
        userIds.push(feedback.user.id.toString()); // converto user id in stringa
      }
    }
    return userIds;
  }
}
